import { Component, inject } from '@angular/core';
import { HarvesterService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import {
  HarvesterCreateDto,
  HarvesterDto,
  HarvesterExcelDownloadDto,
  HarvesterUpdateDto,
} from '../proxy/general/dtos/harvester';
import { HARVESTER_CONFIG, HARVESTER_FIELDS } from './harvester.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-harvester',
  imports: [
    CommonModule,
    CrudPage,
    GenericForm,
    ZnHierarchicalViewComponent
  ],
  providers: [ListService, HarvesterService, ConfirmationService],
  templateUrl: './harvester.html',
  styleUrl: './harvester.scss',
})
export class Harvester extends BaseHierarchicalCrudComponent<
  HarvesterDto,
  HarvesterCreateDto,
  HarvesterUpdateDto,
  HarvesterExcelDownloadDto
> {
  service = inject(HarvesterService);
  config = HARVESTER_CONFIG;
  fields = HARVESTER_FIELDS;

  protected prepareUpdateDto(data: any, selected: HarvesterDto): HarvesterUpdateDto {
    return {
      machineId: data.machineId,
      movilizationTypeId: data.movilizationTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Harvester';
  }
}
